/* eslint-disable no-useless-escape */
import { Input } from '@coinlocally/cly-core';
import { CheckmarkBold, CloseOutline } from '@coinlocally/cly-core/icons';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PasswordInputContainer } from './style';
import { Validator } from 'shared/utils';

const PasswordInput: FC<{
	showDifficulty: boolean;
	input: string;
	error: string;
	type: 'password' | 'reset-password';
	onResetError: () => void;
	setInput: (key: string, value: string) => void;
	position?: 'right' | 'bottom';
}> = ({ showDifficulty, input, error, type, onResetError, setInput, position = 'right' }) => {
	const { t } = useTranslation('components', { keyPrefix: 'password-input' });

	const [suggestVisible, setSuggestVisible] = useState<boolean>(false);
	const [localError, setLocalError] = useState<string>();
	return (
		<PasswordInputContainer>
			<Input
				type='password'
				label={type === 'password' ? t('password') : t('new-password')}
				value={input}
				action={input === '' ? undefined : <CloseOutline />}
				onActionClickHandler={() => setInput('password', '')}
				error={error !== '' ? error : localError !== '' ? localError : ''}
				className='password_input'
				variant='filled'
				autoComplete='new-password'
				onFocus={() => {
					if (input.length > 0 && !suggestVisible) {
						setSuggestVisible(true);
					}

					if (error) {
						onResetError();
					}
				}}
				onChange={e => {
					if (
						!Validator.isStrongPassword(e.target.value, {
							minLength: 5,
							minLowercase: 1,
							minUppercase: 0,
							minNumbers: 0,
							minSymbols: 0,
						})
					) {
						setLocalError(t('please-enter-an-strong-password') || '');
					} else {
						setLocalError('');
					}

					setInput('password', e.target.value);
					if (!suggestVisible) {
						setSuggestVisible(true);
					}
				}}
				onBlur={() => {
					if (suggestVisible) {
						setSuggestVisible(false);
					}
				}}
			/>

			{showDifficulty && suggestVisible && input.length > 0 && (
				<div className={`password_validator ${position}`}>
					<div className={`validator_item ${input.length >= 8 ? 'active' : ''}`}>
						<CheckmarkBold />
						<span>{t('pass-length')}</span>
					</div>
					<div className={`validator_item ${input.match(/[A-Z]/) ? 'active' : ''}`}>
						<CheckmarkBold />
						<span>{t('path-uppercase')} (ex: A, B, C, ...)</span>
					</div>
					<div className={`validator_item ${input.match(/[a-z]/) ? 'active' : ''}`}>
						<CheckmarkBold />
						<span>{t('pass-lowercase')}</span>
					</div>
					<div className={`validator_item ${input.match(/\d/) ? 'active' : ''}`}>
						<CheckmarkBold />
						<span>{t('pass-numeric')} (ex: 1, 2, 3, ...)</span>
					</div>
					<div className={`validator_item ${input.match(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) ? 'active' : ''}`}>
						<CheckmarkBold />
						<span>{t('path-special')} (ex: @, #, $, ...)</span>
					</div>
				</div>
			)}
		</PasswordInputContainer>
	);
};

export default PasswordInput;
